let img = new window.Image()

img.src =
  'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA'

img.onload = img.onerror = () => {
  if (img.height === 2) document.documentElement.classList.add('webp')
  else document.documentElement.classList.add('no-webp')
}
